import { render } from "./security.vue?vue&type=template&id=4906de51"
import script from "./security.js?vue&type=script&lang=js&external"
export * from "./security.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__